export default __webpack_public_path__ + "static/media/tng_logo.1294e28a.svg";